import { isDealTransferIncluded } from "./isDealTransferIncluded";

/**
 * VM לכרטיס „כולל העברות” בהצעת מחיר ללקוח (?offer=1).
 * @param {{ selectedResult?: object|null }} input
 * @returns {{ included: boolean, title: string, subtitle: string } | null}
 */
export function buildPublicOfferIncludedTransfersVm(input = {}) {
  const selectedResult = input.selectedResult ?? null;
  if (!isDealTransferIncluded(selectedResult)) return null;
  return {
    included: true,
    title: "כולל העברות",
    subtitle: "העברות משדה התעופה למלון ובחזרה כלולות בחבילה",
  };
}
